import { httpClient } from './http-client';
import { storageService } from '../../utils/storage';
import type { ApiResponse } from './api.types';
import type { Empresa, Establecimiento } from '../../modelos/Auth';

export const workspaceService = {
  getEmpresas: async (): Promise<ApiResponse<Empresa[]>> => {
    return httpClient.get<Empresa[]>('/empresas');
  },

  getEstablecimientos: async (empresaId?: string): Promise<ApiResponse<Establecimiento[]>> => {
    const params: Record<string, string | number> = { per_page: 200 };
    if (empresaId) params.empresaId = empresaId;
    return httpClient.get<Establecimiento[]>('/establecimientos', params);
  },

  setWorkspace: (empresaId: string, establecimientoId?: string): void => {
    storageService.saveWorkspace(empresaId, establecimientoId);
  },

  getCurrentEmpresaId: (): string | null => {
    return storageService.getEmpresaId();
  },

  getCurrentEstablecimientoId: (): string | null => {
    return storageService.getEstablecimientoId();
  },

  hasWorkspaceContext: (): boolean => {
    return storageService.hasWorkspaceContext();
  },

  clearWorkspace: (): void => {
    storageService.clearWorkspace();
  },

  getCurrentEmpresa: (): Empresa | null => {
    const empresaId = storageService.getEmpresaId();
    if (!empresaId) return null;

    const empresas = storageService.getEmpresas();
    return empresas.find(e => e.id === empresaId) || null;
  },

  getCurrentEstablecimiento: (): Establecimiento | null => {
    const establecimientoId = storageService.getEstablecimientoId();
    if (!establecimientoId) return null;

    const establecimientos = storageService.getEstablecimientos();
    return establecimientos.find(e => e.id === establecimientoId) || null;
  },
};
